import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
var NotFound = /*#__PURE__*/function (_Component) {
  function NotFound() {
    _classCallCheck(this, NotFound);
    return _callSuper(this, NotFound, arguments);
  }
  _inherits(NotFound, _Component);
  return _createClass(NotFound, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement("h1", {
        style: {
          textAlign: 'center',
          width: '100%',
          marginBottom: '1em'
        }
      }, translate('Page not found!')), /*#__PURE__*/React.createElement("h3", {
        style: {
          textAlign: 'center',
          width: '100%'
        }
      }, translate('404 - Page may not exist?')));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps)(NotFound);